import React, { useState, useEffect } from "react";
// Assets
import "~/assets/sass/pages/round/external/external.scss";
import "~/assets/sass/pages/round/common/applicantList.scss";
import { useGlobalStore } from "~/store";
import List from "../list/List";
import InfoModal from "../modal/InfoModal";
import { API_STATE } from "~/common/constants/state";
import useRequest from "~/common/hooks/useRequest";
import { useParams } from "react-router-dom";

const ExternalContainer = () => {
	const [
		{
			external: { userNm },
		},
	] = useGlobalStore();
	const [applyResultModal, setApplyResultModal] = useState(false);
	const [detail, setDetail] = useState();
	const detailRequest = useRequest("get", "/vc/round/external/review/detail", "gitbal", true);
	const defaultRequest = useRequest("get", "/vc/round/external/default");
	const params = useParams();
	const [info, setInfo] = useState();

	const handleGo = (idx) => {
		setApplyResultModal(true);
		handleDetail(idx);
	};

	const handleDetail = (idx) => {
		defaultRequest.call(params.idx, "path");
		detailRequest.call(idx, "path");
	};

	useEffect(() => {
		switch (defaultRequest.state) {
			case API_STATE.done:
				setInfo(defaultRequest.response.data);
				break;
			case API_STATE.error:
				console.log("loginRequest.error >>> ", defaultRequest.error);
				break;
			default:
				break;
		}
	}, [defaultRequest.state, defaultRequest.error, defaultRequest.response]);

	useEffect(() => {
		switch (detailRequest.state) {
			case API_STATE.done:
				const { data } = detailRequest.response;
				setDetail(data);
				break;
			case API_STATE.error:
				console.log("detailRequest.error >>> ", detailRequest.error);
				break;
			default:
				break;
		}
	}, [detailRequest.state, detailRequest.error, detailRequest.response]);

	useEffect(() => {
		const htmlHd = document.getElementById("hd");
		htmlHd.classList.replace("dark", "light");
	}, []);

	return (
		<>
			<List {...{ userNm, handleGo }} />
			<InfoModal
				{...{
					status: info?.status || "",
					userNm,
					applyResultModal,
					setApplyResultModal,
					detail,
					setDetail,
					handleGo,
				}}
			/>
		</>
	);
};

export default ExternalContainer;
